import {
  type ChatModel,
  chatModelSchema,
  createSignalRClient,
} from '@/shared/api'
import { SIGNALR_EVENTS, SIGNALR_HUBS, getSignalRHubUrl } from '@/shared/config'
import { type HubConnectionState } from '@microsoft/signalr'

export class FeedbacksSignalRService {
  private client = createSignalRClient(getSignalRHubUrl(SIGNALR_HUBS.FEEDBACKS))

  async connect(): Promise<void> {
    await this.client.connect()
  }

  async disconnect(): Promise<void> {
    await this.client.disconnect()
  }

  onNewMessage(callback: (message: ChatModel) => void): void {
    this.client.on(SIGNALR_EVENTS.ON_NEW_MESSAGE, (data: unknown) => {
      chatModelSchema
        .parseAsync(data)
        .then((response) => callback(response))
        .catch((error) => {
          console.error('Ошибка валидации данных SignalR:', error)
        })
    })
  }

  offNewMessage(): void {
    this.client.off(SIGNALR_EVENTS.ON_NEW_MESSAGE)
  }

  async sendMessage(feedbackId: string, message: string): Promise<void> {
    await this.client.send('SendMessage', feedbackId, message)
  }

  get isConnected(): boolean {
    return this.client.isConnected
  }

  get connectionState(): HubConnectionState {
    return this.client.connectionState
  }
}

export const feedbacksSignalRService = new FeedbacksSignalRService()
